import { client } from './client';

export const sendLoginEmail = async (email: string, language: string, domain: 'fr' | 'nl' | 'de') => {
  return client.post('v1/auth/send-login-link', {
    email,
    language,
    domain,
  });
};
